// src/index.js

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { aktiveraChunkOmladdning } from './utils/chunkReload';

// Måste kopplas in före render, annars missas chunk-fel från de allra första
// lazy-importerna efter en deploy.
aktiveraChunkOmladdning();


// Hitta root element
const container = document.getElementById('root');

// Skapa en root
const root = createRoot(container);

// Rendera appen
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);